module.exports = Object.freeze({
  environment: localStorage.getItem('environment') || 'prod', // Change this to 'qa' or 'future' as needed
  // baseUrl: "http://reaidy-nodejs-autoscale.azurewebsites.net/api", // azure production api
  // baseUrl: "https://hr-bot-nodejs-server-production.up.railway.app/api",
  baseUrl: 'https://security.reaidy.io',

  qaUrl: 'https://hr-bot-nodejs-server-production-8b89.up.railway.app',
  prodUrl: 'https://security.reaidy.io',
  futureUrl: 'https://future-reaidy.azurewebsites.net',
  testUrl:
    this.environment === 'prod'
      ? this.prodUrl
      : this.environment === 'qa'
        ? this.qaUrl
        : this.futureUrl,
  isTestServer: true,
});
